module.exports = __webpack_public_path__ + "img/Wharton-logo.e5f98398.png";